var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader page-loader-logo"},[_c('img',{staticClass:"mb-4",staticStyle:{"min-width":"100px"},attrs:{"alt":"Logo","src":_vm.logo,"width":"100"}}),_c('atom-spinner',{staticClass:"mx-auto",attrs:{"animation-duration":1500,"size":100,"color":"var(--v-primary-base)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }